import { useState } from "react";

const InputGroup = (props) => {
  const {
    icon = false,
    title = "",
    layout = "right",
    disabled = false,
    type: typeInput = "text",
    withForm = true,
    required = false,
    button = "",
    placeholder = "Type keyword here..",
    value,
    onChange,
    searchHandler,
    maxLength = 100,
  } = props;

  const [search, setSearch] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    if (searchHandler) searchHandler(value ?? search);
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    if (onChange) onChange(e); 
  };

  const inputElement = (
    <input
      type={typeInput}
      className="form-control"
      style={{ borderColor: "#CCCCCC" }}
      placeholder={placeholder}
      aria-label="Example text with button addon"
      aria-describedby="button-addon1"
      onChange={handleChange}
      value={value !== undefined ? value : search} 
      required={required}
      maxLength={maxLength}
    />
  );

  const buttonElement = (
    <button
      className={`btn ${button}`}
      type="submit"
      id="button-addon2"
      style={{ pointerEvents: disabled ? "none" : "auto" }}
    >
      {icon && <i className={icon}></i>}
      {title}
    </button>
  );

  return withForm ? (
    <form onSubmit={submitHandler}>
      <div className="form-group m-0 p-0">
        <div className="input-group">
          {layout === "left" && buttonElement}
          {inputElement}
          {layout === "right" && buttonElement}
        </div>
      </div>
    </form>
  ) : (
    <div className="form-group">
      <div className="input-group">
        {layout === "left" && buttonElement}
        {inputElement}
        {layout === "right" && buttonElement}
      </div>
    </div>
  );
};

export default InputGroup;
